import { render } from "./nticket.vue?vue&type=template&id=3844a93b"
import script from "./nticket.vue?vue&type=script&lang=ts"
export * from "./nticket.vue?vue&type=script&lang=ts"

import "./nticket.vue?vue&type=style&index=0&id=3844a93b&lang=css"
script.render = render

export default script